import { addonManagementApiConnector } from 'apiConnector/addon-management';
import type { AddonManagementEnrichFormRequest } from 'models/forms/AddonManagementEnrichFormRequest';
import type { AddonManagementFormResult } from 'models/forms/AddonManagementFormResult';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of, throwError } from 'rxjs';
import { catchError, filter, map, mergeMap, timeoutWith, withLatestFrom } from 'rxjs/operators';
import { addonManagementFormEnrichmentFailed } from 'state/addonManagementForm/addonManagementForm.action';
import { addonManagementFormEnrichmentReceivedThunk } from 'state/addonManagementForm/addonManagementForm.thunks';
import { getFormEnrichedData } from 'state/selectors';
import type { EpicWithThunk } from 'state/state.common';

export interface AddonManagementFormEnrichmentRequestedEpicApi {
  enrichForm(request: AddonManagementEnrichFormRequest): Observable<AddonManagementFormResult>;
}

// TODO: addonManagement unit test
export function addonManagementFormEnrichmentRequestedEpic(
  timeoutInMillis = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (action$, state$, { httpClient, selectors: { getFormPendingEnrichmentData } }) =>
    action$.pipe(
      ofType('FORM_ENRICHMENT_REQUESTED'),
      filter(({ workspace }) => workspace === 'addonManagement'),
      withLatestFrom(state$),
      mergeMap(([{ formId }, state]) => {
        const pendingData = getFormPendingEnrichmentData(state, formId);
        const enrichedData = { ...getFormEnrichedData(state, formId) };
        const variationParameters = { ...enrichedData, ...pendingData };
        const request: AddonManagementEnrichFormRequest = {
          productId: formId,
          variationParameters: variationParameters,
        };
        return addonManagementApiConnector(httpClient)
          .enrichForm(request)
          .pipe(
            map(({ values, fieldsMetadata, negotiationId, actions, errors }) =>
              addonManagementFormEnrichmentReceivedThunk(values, fieldsMetadata, negotiationId, actions, errors),
            ),
            timeoutWith(timeoutInMillis, throwError(new Error('timeout')), appScheduler),
            catchError(_ => {
              return of(addonManagementFormEnrichmentFailed(formId, pendingData));
            }),
          );
      }),
    );
}
